import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import type { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

import type { Group } from '../models/group.model';

const groupOpportunityURL = (groupId: Group['_id']) =>
  `api/group/${groupId}/opportunity`;
const OPPORTUNITY_API_URL = '/api/opportunity';
const PUBLIC_OPPORTUNITY_V3_API_PREFIX = '/api/v3/public-opportunity';

@Injectable({ providedIn: 'root' })
export class OpportunityBackend {
  v3 = {
    getPublicOpportunity: (opportunityId: string) =>
      this.http.get<Opportunity | null>(
        `${PUBLIC_OPPORTUNITY_V3_API_PREFIX}/${opportunityId}`,
      ),
  };

  constructor(private readonly http: HttpClient) {}

  getOpportunities(params: any) {
    return this.http.get<{ items: Opportunity[]; total_count: number }>(
      OPPORTUNITY_API_URL,
      { params },
    );
  }

  getOpportunity(slug: string) {
    return this.http.get(`${OPPORTUNITY_API_URL}/${slug}`);
  }

  getGroupOpportunity(groupId: Group['slug'], opportunitySlug: string) {
    return this.http.get<{ data: Opportunity }>(
      `${groupOpportunityURL(groupId)}/${opportunitySlug}`,
    );
  }
}
